import React from 'react';
import styled from 'styled-components';

const DocsPage = styled.div`
  max-width: 900px;
  margin: 0 auto;
  padding: 0 20px;
  
  h1 {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 2.5rem;
    font-weight: 700;
    color: #ffffff;
    margin-bottom: 1rem;
    line-height: 1.2;
  }
  
  h2 {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 1.8rem;
    font-weight: 600;
    color: #ffffff;
    margin: 2.5rem 0 1rem 0;
    line-height: 1.3;
  }
  
  h3 {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 1.4rem;
    font-weight: 600;
    color: #ffffff;
    margin: 2rem 0 0.75rem 0;
    line-height: 1.4;
  }
  
  h4 {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 1.1rem;
    font-weight: 600;
    color: #a855f7;
    margin: 1.5rem 0 0.5rem 0;
    line-height: 1.4;
  }
  
  p {
    font-family: 'Roboto', sans-serif;
    font-size: 1rem;
    line-height: 1.7;
    color: #e5e7eb;
    margin-bottom: 1rem;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
  
  ul, ol {
    margin: 1rem 0;
    padding-left: 2rem;
  }
  
  li {
    font-family: 'Roboto', sans-serif;
    font-size: 1rem;
    line-height: 1.7;
    color: #e5e7eb;
    margin-bottom: 0.75rem;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
  
  strong {
    color: #ffffff;
    font-weight: 600;
  }
  
  .effective-date {
    font-family: 'Inter', sans-serif;
    font-size: 0.95rem;
    color: #9ca3af;
    margin-bottom: 2rem;
    font-style: italic;
  }
  
  .warning-box {
    background: rgba(245, 158, 11, 0.1);
    border-radius: 12px;
    padding: 1.5rem;
    margin: 2rem 0;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
  
  .warning-title {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-weight: 700;
    color: #f59e0b;
    font-size: 1.1rem;
    margin-bottom: 0.75rem;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
  
  .warning-text {
    font-family: 'Inter', sans-serif;
    color: #fcd34d;
    font-size: 0.95rem;
    line-height: 1.6;
  }
  
  .info-box {
    background: rgba(59, 130, 246, 0.1);
    border-radius: 12px;
    padding: 1.5rem;
    margin: 2rem 0;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
  
  .info-title {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-weight: 600;
    color: #3b82f6;
    font-size: 1.1rem;
    margin-bottom: 0.75rem;
  }
  
  .info-text {
    font-family: 'Inter', sans-serif;
    color: #d1d5db;
    font-size: 0.95rem;
    line-height: 1.6;
  }
  
  .section-box {
    background: rgba(168, 85, 247, 0.05);
    border-radius: 12px;
    padding: 1.5rem;
    margin: 1.5rem 0;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
  
  .numbered-section {
    margin: 2rem 0;
    padding-left: 1rem;
  }
  
  .acceptance-box {
    background: rgba(16, 185, 129, 0.1);
    border-radius: 12px;
    padding: 2rem;
    margin: 3rem 0;
    text-align: center;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
  
  .acceptance-title {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 1.3rem;
    font-weight: 700;
    color: #10b981;
    margin-bottom: 1rem;
  }
  
  .acceptance-text {
    font-family: 'Inter', sans-serif;
    color: #d1d5db;
    font-size: 1rem;
    line-height: 1.6;
  }
  
  /* Mobile optimizations */
  @media (max-width: 1024px) {
    max-width: 100%;
    padding: 0 16px;
  }
  
  @media (max-width: 768px) {
    max-width: 100%;
    padding: 0 12px;
    
    h1 {
      font-size: 1.8rem;
      margin-bottom: 0.75rem;
    }
    
    h2 {
      font-size: 1.4rem;
      margin: 2rem 0 0.75rem 0;
    }
    
    h3 {
      font-size: 1.2rem;
      margin: 1.5rem 0 0.5rem 0;
    }
    
    h4 {
      font-size: 1rem;
      margin: 1.25rem 0 0.5rem 0;
    }
    
    p {
      font-size: 0.95rem;
      line-height: 1.6;
    }
    
    li {
      font-size: 0.95rem;
      line-height: 1.6;
    }
    
    .warning-box,
    .info-box,
    .section-box {
      padding: 1rem;
      margin: 1.5rem 0;
    }
    
    .acceptance-box {
      padding: 1.5rem;
      margin: 2rem 0;
    }
    
    .numbered-section {
      margin: 1.5rem 0;
      padding-left: 0.75rem;
    }
    
    ul, ol {
      padding-left: 1.5rem;
    }
  }
  
  @media (max-width: 480px) {
    padding: 0 8px;
    
    h1 {
      font-size: 1.6rem;
    }
    
    h2 {
      font-size: 1.3rem;
    }
    
    h3 {
      font-size: 1.1rem;
    }
    
    h4 {
      font-size: 0.95rem;
    }
    
    p, li {
      font-size: 0.9rem;
    }
    
    .warning-box,
    .info-box,
    .section-box {
      padding: 0.75rem;
    }
    
    .acceptance-box {
      padding: 1rem;
    }
    
    .warning-title,
    .info-title,
    .acceptance-title {
      font-size: 1rem;
    }
    
    .warning-text,
    .info-text,
    .acceptance-text {
      font-size: 0.9rem;
    }
  }
`;

const TermsAndConditions: React.FC = () => {
  return (
    <DocsPage>
      <h1>Terms and Conditions</h1>
      
      <p className="effective-date">
        Effective Date: October 21, 2024 | Last Updated: October 21, 2024
      </p>

      <div className="warning-box">
        <div className="warning-title">⚠️ Important Notice</div>
        <div className="warning-text">
          By accessing or using Mavrk ("the Platform"), you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions. Cryptocurrency trading and investing carries substantial risk of loss. You are solely responsible for conducting your own research (DYOR) before participating in any transactions on this Platform.
        </div>
      </div>

      <h2>1. Acceptance of Terms</h2>
      <div className="numbered-section">
        <p>
          These Terms and Conditions ("Terms") constitute a legally binding agreement between you ("User," "you," or "your") and Mavrk ("Platform," "we," "us," or "our"). By accessing, browsing, or using the Platform, you accept and agree to be bound by these Terms and all applicable laws and regulations.
        </p>
        <p>
          <strong>If you do not agree to these Terms, you must immediately cease all use of the Platform.</strong>
        </p>
      </div>

      <h2>2. Platform Description and Services</h2>
      <div className="numbered-section">
        <h3>2.1 Self-Custody Platform</h3>
        <p>
          Mavrk operates as a <strong>non-custodial, self-custody platform</strong> built on EVM-compatible blockchain networks. The Platform provides tools and interfaces that enable users to:
        </p>
        <ul>
          <li>Create and deploy ERC-20 tokens with automatic liquidity provisioning</li>
          <li>Trade tokens through integrated decentralized exchange (DEX) functionality</li>
          <li>Lock tokens for specified time periods using smart contracts</li>
          <li>Bridge assets across multiple blockchain networks</li>
          <li>Manage token holdings and track portfolio performance</li>
        </ul>

        <h3>2.2 Gas Sponsorship</h3>
        <p>
          While the Platform offers <strong>gas sponsorship</strong> for certain transactions through Gelato Network's ERC-2771 relay infrastructure, <strong>users must still sign all transactions</strong> using their own wallet before any action is executed on the blockchain. Gas sponsorship does not eliminate the requirement for user authorization, nor does it transfer custody or control of user assets to the Platform.
        </p>

        <h3>2.3 No Custodial Services</h3>
        <p>
          We do not custody, control, or have access to user funds, private keys, or digital assets at any time. All transactions are executed directly on the blockchain through user-signed messages. You retain complete control and responsibility for your digital assets.
        </p>
      </div>

      <h2>3. Token Creation and Distribution Model</h2>
      <div className="numbered-section">
        <h3>3.1 Fair Launch Mechanism</h3>
        <p>
          All tokens created through the Platform utilize a <strong>100% fair and transparent distribution model</strong> with the following characteristics:
        </p>
        <ul>
          <li><strong>100% Liquidity Allocation:</strong> The entire token supply (1,000,000,000 tokens) is automatically paired into a Reservoir/Relay Protocol V3 (Uniswap V3) or Velodrome V3 liquidity pool upon deployment</li>
          <li><strong>No Pre-Launch Allocations:</strong> There are no airdrops, team allocations, private sales, or pre-launch distributions of any kind</li>
          <li><strong>Market-Only Acquisition:</strong> Every token held by any Externally Owned Account (EOA) must be acquired through open market purchases on the decentralized exchange</li>
          <li><strong>Transparent Distribution:</strong> All token acquisitions are publicly verifiable on the blockchain through transaction history</li>
        </ul>

        <h3>3.2 Permanent Liquidity Locking</h3>
        <p>
          Upon token creation, the liquidity pool NFT (representing the 100% token supply paired with WETH) is <strong>immediately and permanently transferred to the MavrkLocker smart contract</strong> at address <code>0x0f417FaB5b78aaCC265137Ebd83b41c44f515d3F</code>. This mechanism ensures:
        </p>
        <ul>
          <li><strong>Permanent Liquidity:</strong> Liquidity cannot be removed by any party, including the Platform, token creators, or any other entity</li>
          <li><strong>Rug-Pull Prevention:</strong> The locked liquidity prevents malicious removal of trading liquidity</li>
          <li><strong>Fee Collection Only:</strong> The only operation permitted on locked liquidity is the collection of trading fees through the <code>collectFees</code> function, callable by the Platform and token creators</li>
          <li><strong>Immutable Security:</strong> No administrative functions exist to unlock or withdraw liquidity</li>
        </ul>

        <h3>3.3 Fee Distribution</h3>
        <p>
          Trading fees generated from the Reservoir/Relay Protocol V3 (Uniswap V3) or Velodrome V3 liquidity pool (0.3% standard tier) are distributed as follows:
        </p>
        <ul>
          <li><strong>25% Creator Earnings:</strong> Distributed to the original token creator</li>
          <li><strong>75% Platform Fees:</strong> Allocated to Platform operations and development</li>
        </ul>
        <p>
          An additional 1% service fee is collected on swap and bridge operations to facilitate Platform services and maintain infrastructure.
        </p>
      </div>

      <h2>4. Platform Wallet Generation</h2>
      <div className="numbered-section">
        <h3>4.1 Temporary Wallet Creation</h3>
        <p>
          For users who do not have a Web3 wallet, the Platform offers a <strong>temporary wallet generation service</strong> to enable token creation through gasless deployment. This service operates under strict non-custodial principles:
        </p>

        <h3>4.2 Private Key Handling</h3>
        <div className="warning-box">
          <div className="warning-title">Critical Security Notice</div>
          <div className="warning-text">
            <ul>
              <li><strong>One-Time Display:</strong> The private key is displayed to the user ONLY ONCE at the moment of wallet creation</li>
              <li><strong>No Storage:</strong> The Platform does not store, retain, or have access to the private key after its initial display</li>
              <li><strong>User Responsibility:</strong> It is entirely the user's responsibility to securely save and protect the private key</li>
              <li><strong>No Recovery:</strong> The Platform cannot recover, reset, or provide access to lost private keys under any circumstances</li>
              <li><strong>Creator Earnings Access:</strong> Users must import the private key into their own wallet software (e.g., MetaMask) to access creator earnings and manage their tokens</li>
            </ul>
          </div>
        </div>

        <h3>4.3 Security Best Practices</h3>
        <p>
          Users who utilize temporary wallet generation services are strongly advised to:
        </p>
        <ul>
          <li>Immediately save the private key in a secure location</li>
          <li>Never share the private key with any third party</li>
          <li>Import the wallet into a secure wallet application</li>
          <li>Transfer any valuable assets to a hardware wallet for long-term storage</li>
          <li>Understand that loss of the private key results in permanent loss of access to the wallet and its contents</li>
        </ul>
      </div>

      <h2>5. Blockchain Transparency and Verification</h2>
      <div className="numbered-section">
        <h3>5.1 On-Chain Operations</h3>
        <p>
          All actions performed on the Platform are executed as <strong>blockchain transactions</strong> that are publicly visible, verifiable, and immutable. This includes but is not limited to:
        </p>
        <ul>
          <li><strong>Token Creation:</strong> Smart contract deployment and liquidity provisioning</li>
          <li><strong>Liquidity Pool Locking:</strong> Permanent locking of liquidity pool assets</li>
          <li><strong>Token Trading:</strong> Buy and sell operations through a V3 DEX swap router contract</li>
          <li><strong>Token Locking:</strong> Time-lock deposits to MavrkTokenLocker contract</li>
          <li><strong>Linear Token Vesting:</strong> Time-lock linear token vesting deposits to MavrkLinearVesting contract</li>
          <li><strong>Cross-Chain Bridging:</strong> Asset transfers via Relay Protocol</li>
          <li><strong>Fee Collection:</strong> Creator earnings and platform fee distributions</li>
        </ul>

        <h3>5.2 No Hidden Logic</h3>
        <div className="info-box">
          <div className="info-title">Transparency Commitment</div>
          <div className="info-text">
            <p>
              The Platform operates with complete transparency and does not employ:
            </p>
            <ul>
              <li><strong>No Bonding Curves:</strong> Token prices are determined exclusively by market supply and demand in a Concentrated Liquidity Market Maker (CLMM) model that utilizes an Automated Market Maker (AMM) pricing model by distributing LP across a full trading range</li>
              <li><strong>No Hidden Operations:</strong> All smart contract interactions are visible on the blockchain</li>
              <li><strong>No Privileged Access:</strong> The Platform does not have special privileges to manipulate token prices or liquidity</li>
              <li><strong>No Off-Chain Computation:</strong> All critical operations occur on-chain with verifiable proof</li>
            </ul>
          </div>
        </div>

        <h3>5.3 Verification Rights</h3>
        <p>
          Users may verify all Platform operations by:
        </p>
        <ul>
          <li>Inspecting smart contract source code on the Ink L2 block explorer</li>
          <li>Reviewing transaction history for any address or token</li>
          <li>Monitoring liquidity pool states and trading activity</li>
          <li>Tracking token holder distributions and transfer events</li>
          <li>Auditing fee collection and distribution mechanisms</li>
        </ul>
      </div>

      <h2>6. Risk Disclosures and Disclaimers</h2>
      <div className="numbered-section">
        <div className="warning-box">
          <div className="warning-title">Investment Risk Warning</div>
          <div className="warning-text">
            <p>
              <strong>TRADING AND INVESTING IN CRYPTOCURRENCIES IS HIGHLY SPECULATIVE AND CARRIES SUBSTANTIAL RISK OF FINANCIAL LOSS.</strong>
            </p>
            <p>
              Cryptocurrency markets are extremely volatile and can experience rapid, significant price fluctuations. You may lose some or all of your invested capital. Past performance is not indicative of future results.
            </p>
          </div>
        </div>

        <h3>6.1 User Responsibility for Research</h3>
        <p>
          <strong>DO YOUR OWN RESEARCH (DYOR)</strong> - Users are solely responsible for:
        </p>
        <ul>
          <li>Conducting independent research and due diligence on all tokens before investing</li>
          <li>Evaluating the risks, rewards, and suitability of any investment</li>
          <li>Understanding the technical aspects of blockchain technology and smart contracts</li>
          <li>Assessing their own risk tolerance and financial situation</li>
          <li>Seeking professional financial, legal, and tax advice as appropriate</li>
        </ul>

        <h3>6.2 Not Financial Advice (NFA)</h3>
        <p>
          The Platform does not provide investment advice, financial planning services, or recommendations regarding the purchase or sale of any cryptocurrency or token. No content on the Platform should be construed as:
        </p>
        <ul>
          <li>Investment, financial, legal, or tax advice</li>
          <li>An offer to sell or solicitation to buy any security or financial instrument</li>
          <li>An endorsement or recommendation of any token, project, or investment strategy</li>
          <li>A guarantee of future performance or results</li>
        </ul>

        <h3>6.3 Smart Contract Risks</h3>
        <p>
          Users acknowledge and accept the following risks associated with smart contract technology:
        </p>
        <ul>
          <li><strong>Code Vulnerabilities:</strong> Smart contracts may contain bugs, vulnerabilities, or design flaws that could result in loss of funds</li>
          <li><strong>Irreversible Transactions:</strong> Blockchain transactions are generally irreversible and cannot be undone</li>
          <li><strong>Network Risks:</strong> Blockchain networks may experience congestion, forks, or technical failures</li>
          <li><strong>Protocol Changes:</strong> Underlying blockchain protocols may undergo changes that affect token functionality</li>
        </ul>

        <h3>6.4 Third-Party Dependencies</h3>
        <p>
          The Platform integrates with third-party protocols and services, including:
        </p>
        <ul>
          <li>Reservoir/Relay Protocol (Uniswap V3) or Velodrome V3 smart contracts for liquidity provisioning and token swaps</li>
          <li>Gelato Network for gasless transaction relay</li>
          <li>Relay Protocol for cross-chain bridging</li>
          <li>RPC providers for blockchain connectivity</li>
        </ul>
        <p>
          We do not control these third-party services and are not responsible for their operation, security, or availability.
        </p>

        <h3>6.5 Regulatory Uncertainty</h3>
        <p>
          The regulatory status of cryptocurrencies, tokens, and decentralized finance (DeFi) platforms varies by jurisdiction and remains subject to change. Users are responsible for:
        </p>
        <ul>
          <li>Understanding and complying with applicable laws and regulations in their jurisdiction</li>
          <li>Determining whether their use of the Platform is lawful</li>
          <li>Paying any applicable taxes on cryptocurrency transactions</li>
          <li>Obtaining any required licenses or approvals</li>
        </ul>
      </div>

      <h2>7. User Representations and Warranties</h2>
      <div className="numbered-section">
        <p>
          By using the Platform, you represent and warrant that:
        </p>
        <ul>
          <li>You are at least 18 years of age and have the legal capacity to enter into these Terms</li>
          <li>Your use of the Platform complies with all applicable laws and regulations</li>
          <li>You are not located in, organized in, or a resident of any jurisdiction where cryptocurrency activities are prohibited</li>
          <li>You understand the risks associated with cryptocurrency trading and blockchain technology</li>
          <li>You are using the Platform solely for lawful purposes</li>
          <li>You have secured your private keys and wallet access credentials</li>
          <li>You accept full responsibility for all transactions executed through your wallet</li>
        </ul>
      </div>

      <h2>8. Prohibited Activities</h2>
      <div className="numbered-section">
        <p>
          Users are expressly prohibited from:
        </p>
        <ul>
          <li>Using the Platform for money laundering, terrorist financing, or other illegal activities</li>
          <li>Manipulating markets, engaging in wash trading, or conducting fraudulent transactions</li>
          <li>Attempting to circumvent or manipulate Platform security measures or fee structures</li>
          <li>Interfering with the proper operation of the Platform or its smart contracts</li>
          <li>Violating any applicable laws, regulations, or third-party rights</li>
          <li>Creating tokens that infringe intellectual property rights or impersonate other projects</li>
          <li>Deploying malicious smart contracts or executing harmful transactions</li>
          <li>Using blacklisted words, phrases, or terms in token names, symbols, or descriptions that are considered racial slurs, hate speech, or other crude, offensive, or inappropriate content</li>
        </ul>
        
        <div className="info-box">
          <div className="info-title">Content Moderation</div>
          <div className="info-text">
            <p>
              The Platform maintains a dynamic blacklist of prohibited words, phrases, and terms that are considered offensive, inappropriate, or harmful. This blacklist includes but is not limited to racial slurs, hate speech, explicit content, and other crude or offensive language.
            </p>
            <p>
              The Platform reserves the right to add, remove, or modify blacklisted content at any time without prior notice. Tokens containing blacklisted content in their name, symbol, or description may be filtered from Platform interfaces, though they will remain functional on the blockchain.
            </p>
          </div>
        </div>
      </div>

      <h2>9. Limitation of Liability</h2>
      <div className="numbered-section">
        <div className="warning-box">
          <div className="warning-title">Liability Disclaimer</div>
          <div className="warning-text">
            <p>
              TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, THE PLATFORM AND ITS OPERATORS, DEVELOPERS, AND AFFILIATES SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS, REVENUES, DATA, OR USE, ARISING OUT OF OR RELATED TO YOUR USE OF THE PLATFORM, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
            </p>
            <p>
              <strong>THE PLATFORM IS A PERMISSIONLESS, NON-CUSTODIAL INTERFACE. YOU ACKNOWLEDGE AND AGREE THAT THE PLATFORM OPERATORS HAVE NO LIABILITY WHATSOEVER FOR ANY LOSSES, DAMAGES, OR CONSEQUENCES ARISING FROM YOUR USE OF THE PLATFORM OR BLOCKCHAIN TRANSACTIONS.</strong>
            </p>
          </div>
        </div>

        <p>
          The Platform is provided "AS IS" and "AS AVAILABLE" without warranties of any kind, whether express or implied, including but not limited to warranties of merchantability, fitness for a particular purpose, or non-infringement.
        </p>

        <p>
          We do not warrant that:
        </p>
        <ul>
          <li>The Platform will be uninterrupted, secure, or error-free</li>
          <li>The results obtained from using the Platform will be accurate or reliable</li>
          <li>Any errors in the Platform will be corrected</li>
          <li>The Platform or its servers are free of viruses or other harmful components</li>
        </ul>
      </div>

      <h2>10. Indemnification</h2>
      <div className="numbered-section">
        <p>
          You agree to indemnify, defend, and hold harmless the Platform and its operators, developers, affiliates, and service providers from and against any and all claims, liabilities, damages, losses, costs, and expenses (including reasonable attorney fees) arising out of or related to:
        </p>
        <ul>
          <li>Your use of or inability to use the Platform</li>
          <li>Your violation of these Terms</li>
          <li>Your violation of any rights of another party</li>
          <li>Your violation of any applicable laws or regulations</li>
          <li>Any transactions you execute using the Platform</li>
        </ul>
      </div>

      <h2>11. Service Fees</h2>
      <div className="numbered-section">
        <h3>11.1 Transaction Fees</h3>
        <p>
          The Platform collects a <strong>1% service fee</strong> on the following operations:
        </p>
        <ul>
          <li><strong>Token Swaps:</strong> 1% fee on the input amount for facilitating trades through Reservoir/Relay Protocol (Uniswap V3) or Velodrome V3 DEX contracts</li>
          <li><strong>Cross-Chain Bridging:</strong> 1% fee on the bridged amount for facilitating asset transfers via Relay Protocol</li>
        </ul>

        <h3>11.2 Multi-Call Architecture</h3>
        <p>
          To provide a seamless user experience, the Platform utilizes <strong>multi-call functionality</strong> that batches multiple operations into single transactions. This architecture:
        </p>
        <ul>
          <li>Reduces the number of user signatures required</li>
          <li>Minimizes gas costs through optimized execution</li>
          <li>Maintains complete transparency through on-chain verification</li>
          <li>Ensures atomic execution of complex operations</li>
        </ul>

        <h3>11.3 Fee Adjustments</h3>
        <p>
          The Platform reserves the right to adjust service fees with reasonable notice to users. Continued use of the Platform following fee adjustments constitutes acceptance of the new fee structure.
        </p>
      </div>

      <h2>12. Termination</h2>
      <div className="numbered-section">
        <p>
          We reserve the right to suspend or terminate your access to the Platform at any time, with or without cause, and with or without notice, for conduct that we believe violates these Terms or is harmful to other users, the Platform, or third parties, or for any other reason in our sole discretion.
        </p>
        <p>
          Upon termination, your right to use the Platform will immediately cease. However, because the Platform is non-custodial and operates on public blockchain networks, we cannot prevent you from interacting directly with smart contracts or blockchain networks.
        </p>
      </div>

      <h2>13. Modifications to Terms</h2>
      <div className="numbered-section">
        <p>
          We reserve the right to modify these Terms at any time. We will notify users of material changes by posting the updated Terms on the Platform with a new "Last Updated" date. Your continued use of the Platform following such modifications constitutes your acceptance of the updated Terms.
        </p>
        <p>
          We encourage you to periodically review these Terms to stay informed of any changes.
        </p>
      </div>

      <h2>14. Governing Law and Dispute Resolution</h2>
      <div className="numbered-section">
        <h3>14.1 Governing Law</h3>
        <p>
          These Terms shall be governed by and construed in accordance with the laws of the jurisdiction where the Platform operates, without regard to its conflict of law provisions.
        </p>

        <h3>14.2 Arbitration</h3>
        <p>
          Any dispute, controversy, or claim arising out of or relating to these Terms or your use of the Platform shall be resolved through binding arbitration in accordance with the rules of a mutually agreed arbitration service. The arbitration shall be conducted in English.
        </p>

        <h3>14.3 Class Action Waiver</h3>
        <p>
          <strong>You agree that any dispute resolution proceedings will be conducted only on an individual basis and not in a class, consolidated, or representative action.</strong>
        </p>
      </div>

      <h2>15. Miscellaneous</h2>
      <div className="numbered-section">
        <h3>15.1 Entire Agreement</h3>
        <p>
          These Terms constitute the entire agreement between you and the Platform regarding your use of the Platform and supersede all prior agreements and understandings.
        </p>

        <h3>15.2 Severability</h3>
        <p>
          If any provision of these Terms is found to be invalid or unenforceable, the remaining provisions shall continue in full force and effect.
        </p>

        <h3>15.3 Waiver</h3>
        <p>
          No waiver of any term or condition of these Terms shall be deemed a further or continuing waiver of such term or condition or any other term or condition.
        </p>

        <h3>15.4 Assignment</h3>
        <p>
          You may not assign or transfer these Terms or your rights and obligations hereunder without our prior written consent. We may assign or transfer these Terms without restriction.
        </p>

        <h3>15.5 Contact Information</h3>
        <p>
          For questions or concerns regarding these Terms, please contact us through the Platform's documentation or support channels.
        </p>
      </div>

      <div className="acceptance-box">
        <div className="acceptance-title">Acknowledgment of Terms</div>
        <div className="acceptance-text">
          <p>
            <strong>BY ACCESSING OR USING MAVRK, YOU ACKNOWLEDGE THAT YOU HAVE READ, UNDERSTOOD, AND AGREE TO BE BOUND BY THESE TERMS AND CONDITIONS.</strong>
          </p>
          <p>
            <strong>IF YOU DO NOT AGREE TO THESE TERMS, YOU MUST NOT USE THE PLATFORM.</strong>
          </p>
          <p style={{ marginTop: '1.5rem', fontSize: '0.9rem', color: '#9ca3af' }}>
            Users are encouraged to seek independent legal advice regarding their use of the Platform and compliance with applicable laws and regulations in their jurisdiction.
          </p>
        </div>
      </div>

    </DocsPage>
  );
};

export default TermsAndConditions;
